import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import MDRHero from '../components/MDR/MDRHero';
import MDRServices from '../components/MDR/MDRServices';
import MDRBenefits from '../components/MDR/MDRBenefits';
import SocAsAService from '../components/MDR/socasaservice';
import SOCBenefits from '../components/MDR/SOCBenefits';
import ContactSection from '../components/layout/ContactSection';
import Footer from '../components/layout/footer';

const SolutionsMDR = () => {
  useEffect(() => {
    const handleContextMenu = (e) => e.preventDefault();

    const handleKeyDown = (e) => {
      if (
        e.keyCode === 123 || 
        (e.ctrlKey && e.shiftKey && (e.keyCode === 73 || e.keyCode === 74)) || 
        (e.ctrlKey && e.keyCode === 85) 
      ) {
        e.preventDefault();
      }
    };

    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const stats = [
    { label: "Daily Attacks", value: "2,200+", detail: "One every 39 seconds globally." },
    { label: "Daily Alerts", value: "11,000", detail: "Over 50% are false positives." },
    { label: "Alert Fatigue", value: "53%", detail: "Of threats go uninvestigated." }
  ];

  return (
    <div className="min-h-screen ] text-white">
      {/* Hero Section */}
      <MDRHero />
      <section className="pt-32 pb-1 px-6">
        <div className="max-w-7xl mx-auto text-center">
          <motion.h1 
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            className="mt-6 text-5xl md:text-4xl font-black tracking-tighter"
          >
            STOP BREACHES BEFORE <span className="text-[#4CBB17]"> THEY BECOME HEADLINES</span>
          </motion.h1>
          <p className="mt-8 max-w-2xl mx-auto text-gray-400 text-lg leading-relaxed">
            Today’s attackers use AI, automation, and sophisticated techniques to strike quickly and quietly. 
            Waiting for the next alert won’t protect you anymore. Most companies today are drowning in alerts, struggling with talent shortages, and 
            watching security costs spiral out of control—while threats grow faster and smarter every day.
          </p>
        </div>

        {/* Compact Stats Grid */}
        <div className="w-full flex justify-center py-2 px-0">
          <div className="w-[70%] grid grid-cols-1 md:grid-cols-3 mx-auto border-t border-b border-white/5 py-10">
            {stats.map((s, i) => (
              <motion.div 
                key={i} 
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}

                className={`relative px-6 md:px-10 py-6 flex flex-col items-center text-center gap-3 group transition-all
                  ${i !== 0 ? 'md:border-l border-white/5' : ''}`}
              >
                {/* Label and Dot */}
                <div className="flex items-center gap-2">
                  <div className="w-1 h-1 rounded-full bg-emerald-500/50 group-hover:bg-emerald-500 transition-colors" />
                  <p className="text-emerald-500 font-mono text-[12px] tracking-[0.3em] uppercase opacity-80">
                    {s.label}
                  </p>
                </div>

                {/* Value */}
                <h3 className="text-4xl md:text-6xl font-light tracking-tighter text-white group-hover:text-emerald-400 transition-colors duration-500">
                  {s.value}
                </h3>

                {/* Detail - Added max-w to keep the centered text block compact */}
                <p className="max-w-[100%] text-gray-500 text-[15px] leading-relaxed font-medium tracking-wide group-hover:text-gray-400 transition-colors">
                  {s.detail}
                </p>

                {/* Hover accent line */}
                <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-0 h-[1px] bg-emerald-500/50 group-hover:w-full transition-all duration-700" />
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      
      <section id="MDRServices" className="scroll-mt-14">
        <MDRServices />
      </section>
      <MDRBenefits />
      <section id="SocAsAService" className="scroll-mt-24">
        <SocAsAService /> 
      </section>
         
      <SOCBenefits /> 
      <ContactSection />
      <Footer />
    
    </div>   
  );
};

export default SolutionsMDR;